import getExampleReselect from './loaded/getExampleReselect';

export * from './loaded/simple';

export {
  getExampleReselect,
};
